import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutLogout24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowOutLogout24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 7.25A3.25 3.25 0 0 1 7.25 4h5.5a.75.75 0 0 1 0 1.5h-5.5A1.75 1.75 0 0 0 5.5 7.25v9.5c0 .966.784 1.75 1.75 1.75h5.5a.75.75 0 0 1 0 1.5h-5.5A3.25 3.25 0 0 1 4 16.75zM9.25 12a.75.75 0 0 1 .75-.75h7.12l-1.9-1.9a.75.75 0 0 1 1.06-1.06l3.182 3.182.53.53-.53.53-3.182 3.182a.75.75 0 1 1-1.06-1.06l1.903-1.904H10a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutLogout24);
